var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Configuration_in_cyberspace_for_security._2_",
    "data-name": "Configuration in cyberspace for security. (2)",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M7.206,1.752a.558.558,0,0,1,.555-.5h2.977a.558.558,0,0,1,.555.5l.172,1.719a.186.186,0,0,0,.3.127L13.106,2.5a.558.558,0,0,1,.748.037l2.105,2.1A.558.558,0,0,1,16,5.394L14.9,6.732a.186.186,0,0,0,.125.3l1.721.171a.558.558,0,0,1,.5.556v2.977a.558.558,0,0,1-.5.555l-1.72.172a.186.186,0,0,0-.126.3L16,13.106a.558.558,0,0,1-.037.749l-2.1,2.1a.558.558,0,0,1-.748.037L11.769,14.9a.186.186,0,0,0-.3.125l-.171,1.721a.558.558,0,0,1-.556.5H7.762a.558.558,0,0,1-.555-.5l-.172-1.721a.186.186,0,0,0-.3-.125L5.394,16a.558.558,0,0,1-.748-.037l-2.105-2.1a.558.558,0,0,1-.037-.748L3.6,11.768a.186.186,0,0,0-.125-.3l-1.719-.171a.558.558,0,0,1-.5-.556V7.762a.558.558,0,0,1,.5-.555l1.721-.172a.186.186,0,0,0,.125-.3L2.5,5.394a.558.558,0,0,1,.037-.749l2.1-2.1A.558.558,0,0,1,5.394,2.5L6.732,3.6a.186.186,0,0,0,.3-.125l.171-1.719Zm1.06.614L8.145,3.583a1.3,1.3,0,0,1-2.121.878l-.946-.774L3.687,5.077l.775.947a1.3,1.3,0,0,1-.878,2.121l-1.217.121v1.966l1.217.122a1.3,1.3,0,0,1,.878,2.121l-.774.946,1.391,1.391.947-.775a1.3,1.3,0,0,1,2.121.878l.121,1.217h1.966l.122-1.217a1.3,1.3,0,0,1,2.121-.878l.946.774,1.391-1.39-.774-.947a1.3,1.3,0,0,1,.878-2.121l1.217-.121V8.268l-1.217-.122a1.3,1.3,0,0,1-.878-2.121l.775-.947-1.391-1.39-.947.774a1.3,1.3,0,0,1-2.121-.878l-.121-1.217H8.268Z",
    transform: "translate(0 0)",
    fill: "#6249ef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M10.785,8.366A2.419,2.419,0,1,0,13.2,10.785,2.419,2.419,0,0,0,10.785,8.366ZM7.25,10.785a3.535,3.535,0,1,1,3.535,3.535A3.535,3.535,0,0,1,7.25,10.785Z",
    transform: "translate(-1.535 -1.535)",
    fill: "#6249ef",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsBlue);
export default __webpack_public_path__ + "static/media/settingsBlue.f1f47aca74ef23fcc92350105a02f3d5.svg";
export { ForwardRef as ReactComponent };